'use strict'

const { queueThunk } = require('dbsm-common/src/redux/queuedThunk')
const ACTION_QUEUE = Symbol('action-queue')

module.exports = thunk => queueThunk(thunk, ACTION_QUEUE)



// WEBPACK FOOTER //
// ./actions-queue/addToQueue.js